module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isReadOnly === true) ? _c('v-alert', {
    staticClass: "pa-2",
    attrs: {
      "value": "true",
      "type": "warning",
      "dismissible": "",
      "color": "error"
    }
  }, [_vm._v("Account is not active. It is in read-only mode\n    "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showmore = true
      }
    }
  }, [_vm._v("More info")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.billingUrl,
      "target": "_blank",
      "color": "primary"
    }
  }, [_vm._v("Reactivate account\n      "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "xs12": "",
      "dense": "",
      "type": "error",
      "width": "460"
    },
    model: {
      value: (_vm.showmore),
      callback: function($$v) {
        _vm.showmore = $$v
      },
      expression: "showmore"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-1"
  }, [_vm._v("\n        Account is in read-only mode\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showmore = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "mb-3",
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('center', [_c('v-btn', {
    attrs: {
      "flat": "",
      "text": "",
      "href": "mailto:support@appointmentguru.co",
      "target": "_blank"
    }
  }, [_vm._v("\n          Contact support\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "flat": "",
      "text": "",
      "target": "_blank",
      "href": "https://appointmentguru.co/help/why-am-i-seeing-an-upgrade-notice"
    }
  }, [_vm._v("\n          Why am I seeing this\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.billingUrl,
      "target": "_blank",
      "color": "primary"
    }
  }, [_vm._v("Reactivate account\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4240ca4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/ReadOnlyBlock.vue
// module id = 1506
// module chunks = 9